import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';

@Component({
  selector: 'app-audio-player-controler',
  templateUrl: './audio-player-controler.component.html',
  styleUrl: './audio-player-controler.component.scss'
})
export class AudioPlayerControlerComponent extends BaseComponent implements OnInit, OnChanges {
  @Input() isPlaying: boolean = false;
  @Input() isRecording: boolean = false;
  @Input() isProcessing: boolean = false;
  @Input() isAudioOn: boolean = true;
  @Output() playbackToggled = new EventEmitter<boolean>();

  imageRootFolder: string = '/assets/common/';

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    console.log('AudioPlayerControlerComponent OnInit isRecording', this.isRecording);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.ifChanged(changes.isRecording, () => {
      console.log('isRecording changed', this.isRecording);
    });

    this.ifChanged(changes.isPlaying, () => {
      console.log('isPlaying changed', this.isPlaying);
    });

    this.ifChanged(changes.isProcessing, () => {
      console.log('AUDIODBG', new Date().toISOString(), 'isProcessing changed', this.isProcessing);
    });

    console.log('AudioPlayerControlerComponent onChanges isRecording', this.isRecording);
  }

  togglePlayback(): void {
    if (this.isAudioOn) {
      this.isPlaying = !this.isPlaying;
      this.playbackToggled.emit(this.isPlaying);
    }
  }
}
